<template>
  <div class="home">
    <div class="party" @click="jumpDangPage"><img class="partyRight" src="../../assets/images/dang.png" /></div>
    <div class="home-m">
      <el-row :gutter="20" class="title" style="margin-top:-20px;">
          <el-col :span="6" :xs="6" class="title-l">
            <p>最新公告</p>
            <img src="../../assets/images/title-icon.png" style="margin-top: -20px;"/>
          </el-col>
          <el-col :span="18" :xs="18" >
          </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" :xs="6" v-for="(news, index1) in newnestList" :key="index1">
          <div @click="jumpDocInfo(news.doc_id, 5)" style="cursor:pointer">
            <el-card class="box-card" v-if="index1 < 4">
              <div class="tl fs14 fc">{{news.showDate?news.showDate.substring(0,10):''}}</div>
              <div class="line">&nbsp;</div>
              <div class="tl fs15 line2 fw600">{{news.notice_title}}</div>
              <div class="btn-g">查看详情>></div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="search home-m" style="margin-top:20px;">
        <div><img src="../../assets/images/search.jpg" /></div>
        <el-row :gutter="20" :model="searchInfo" class="search-mt">
          <el-col :span="6" class="row-col">
            <label>查询范围：</label>
              <el-select v-model="searchInfo.findScope" placeholder="全站">
                  <el-option value="全站">全站</el-option>
                  <el-option
                      v-for="item in selectList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
              </el-select>
          </el-col>
          <el-col :span="6" class="row-col">
            <label>查询方式：</label>
            <el-select
              v-model="searchInfo.findWay"
              collapse-tags
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in selectList2"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          
          <el-col :span="8" class="row-col">
            <label>查询内容：</label>
            <el-input v-model="searchInfo.findContent" clearable placeholder="请输入"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" class="btn-search" @click="goTotalSearch" icon="el-icon-search">查询</el-button>
          </el-col>
        </el-row>
    </div>
    <div class="home-m">
      <el-row :gutter="20" class="title">
          <el-col :span="24" :xs="24" class="title-l">
            <p>行业动态</p>
            <img src="../../assets/images/title-icon.png" />
          </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="14">
          <div class="row1-l tab-r">
              <el-tabs v-model="activeName" @tab-click="handleClick" tab-position="top">
                <el-tab-pane v-for="(tab,a) in industryTabs" :key="a" :label="tab.label">
                  <span slot="label">
                    {{tab.label}}
                    <el-badge v-show="tab.count>0" :value="tab.count"></el-badge>
                  </span>
                  <div v-for="(item, index) in industryDynamicList" :key="index">
                    <a href="#" v-if="index < 5" @click="jumpDocInfo(item.doc_id, a+1)" style="color: #000">
                      <el-row :gutter="20" class="row-tab">
                        <el-col :span="16">
                          <div class="tab-info">
                            <span>{{item.industry_title}}</span>
                          </div>
                        </el-col>
                        <el-col :span="2" v-show="getNewFlg(item.showDate)">
                          <img v-show="getNewFlg(item.showDate)" style="width:35px;" :src="require('../../assets/images/new.png')" />
                        </el-col>
                        <el-col :span="2" v-show="!getNewFlg(item.showDate)">
                          <div style="width:35px;">&nbsp;</div>
                        </el-col>
                        <el-col :span="5">
                          <span class="tabspan-r">{{item.showDate?item.showDate.substring(0, 10):''}}</span>
                        </el-col>
                      </el-row>
                    </a>
                  </div>                  
                  <div class="tab-more" @click="jumpImgPage(tab.name)"><a>更多>></a></div>
                </el-tab-pane>
              </el-tabs>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="row1-r">
            <el-carousel :interval="30000" arrow="hover" indicator-position="none" height="310px">
              <el-carousel-item v-for="img, i in imageList" :key="i" >
                <a @click="jumpDocInfo(img.docId, 1)">
                  <img :src="img.img" />
                  <el-tooltip class="item" effect="dark" :content="img.title" placement="bottom-start">
                    <span class="title-span" style="border:solid 1px #fff">{{ img.title }}</span>
                  </el-tooltip> 
                </a>               
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>
    </div>    

    <div class="home-full" id="target">
      <div class="home-75 fw">
        <el-row :gutter="20" class="title">
          <el-col :span="6" :xs="6" class="title-l mt-20">
            <p>服务平台</p>
            <img src="../../assets/images/title-icon.png" />
          </el-col>
          <el-col :span="18" :xs="18" >
          </el-col>
        </el-row>        

        <el-row :gutter="20" class="title h-260-title">
            <el-col :span="24" :xs="24" class="title-l">
              <p class="service">协会网上办事</p>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="h-260">
            <el-col :span="8" :xs="8" class="border-r">
              <div @click="handleJump('/AboutUs?tab=7')" style="cursor:pointer">
                <img src="../../assets/images/home/加入协会.png" />
                <p class="mt fw700">加入协会</p>
              </div>
            </el-col>
            <el-col :span="8" :xs="8" class="border-r">
              <div  @click="goOASystem" style="cursor:pointer">
                <img src="../../assets/images/home/协会网上办事系统.png" />
                <p class="mt fw700">协会网上办事系统</p>
              </div>
            </el-col>
            <el-col :span="8" :xs="8">
              <div  @click="handleJump('/SearchBlock')" style="cursor:pointer">
                <img src="../../assets/images/home/查询专区.png" />
                <p class="mt fw700">查询专区</p>
              </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="title h-260-title">
            <el-col :span="24" :xs="24" class="title-l">
              <p class="service">申报/管理系统</p>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="h-260">
            <el-col :span="6" :xs="6" class="border-r" >
              <div @click="goRsj('http://zhywglxt.cnaec.com.cn/#/consultant_login')" style="cursor:pointer">
                <img src="../../assets/images/home/综合业务管理系统.png" />
                <a href="#" ><p class="mt fw700">综合业务管理系统</p></a>
              </div>
            </el-col>
            <el-col :span="6" :xs="6" class="border-r">
              <div @click="goRsj('https://edu.secta.sh.cn/index/')" style="cursor:pointer">
                <img src="../../assets/images/home/继续教育平台.png" />
                <a href="#"><p class="mt fw700">继续教育平台</p></a>
              </div>
            </el-col>
            <el-col :span="6" :xs="6" class="border-r">
              <div  @click="goGaozhiDetail('9f2091e816194dc88a0f2b98482dcd45')" style="cursor:pointer">
                <img src="../../assets/images/home/告知性备案系统.png" />
                <p class="mt fw700">告知性备案系统</p>
              </div>
            </el-col>
            <el-col :span="6" :xs="6">
              <div @click="goRsj('https://rsj.sh.gov.cn/trsks_17824/index.html')" style="cursor:pointer">
                <img src="../../assets/images/home/考试报名系统.png" />
                <a href="#"><p class="mt fw700">考试报名系统</p></a>
              </div>
            </el-col>
        </el-row>
      </div>
    </div>
    <div class="home-full-2">
      <div class="home-75">
        <el-row :gutter="20" class="title">
            <el-col :span="6" :xs="6" class="title-l">
              <p style="color: #000">行业精英</p>
              <img src="../../assets/images/title-icon.png" />
            </el-col>
            <el-col :span="18" :xs="18" >
              <div class="tab-more-black" @click="handleJump('/TalentDevelop?tab=2')"><a>查看更多>></a></div>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="h-460">
            <el-col :span="24" :xs="24">
              <div class="carousel">
                <el-carousel :interval="4000" type="card" indicator-position="none" height="450px">
                  <el-carousel-item v-for="(item, i) in eliteList" :key="i">
                    <div @click="handlePersonInfo(item.doc_id)">
                      <div class="imgBoxNew">
                        <img class="imgItem" v-lazy="item.img_url" :key="item.img_url" alt="" srcset="" />
                      </div>
                      <p class="imgTit">{{ item.elite_name }}</p>
                      <p class="imgTit2">{{ item.doc_abstract }}</p>
                    </div> 
                  </el-carousel-item>
                </el-carousel>
              </div>
            </el-col>
        </el-row>
      </div>
    </div>
    <div class="home-full-3">
      <div class="home-75 fw ">
        <el-row :gutter="20" class="title">
            <el-col :span="6" :xs="6" class="title-l" style="margin-top: 20px;">
              <p>成果展示</p>
              <img src="../../assets/images/title-icon.png" />
            </el-col>
            <el-col :span="18" :xs="18" style="margin-top: 20px;">
              <div class="tab-more-elite" @click="handleJump('/ExcellentAchievements?tab=2')"><a>查看更多>></a></div>
            </el-col>
            <!-- <el-col :span="2" :xs="2" class="mt-5" >
              <img class="mt-5-img" src="../../assets/images/right.png" @click="handleJump('/ExcellentAchievements?tab=2')" />
            </el-col> -->
        </el-row>
        <div class="hl30"></div>
        <div v-if="resultShowList && resultShowList.length > 0">
          <el-row class="h-240">
              <el-col :span="6" :xs="6">
                <div class="content" @click="handleMore(resultShowList[0].doc_id, '/ExcellentAchievements', '优秀成果')" style="cursor:pointer">
                  <p class="fontW line1">{{resultShowList[0]?resultShowList[0].result_title:''}}</p>
                  <p class="mt line4">{{resultShowList[0].doc_abstract?resultShowList[0].doc_abstract:''}}</p>
                  <p class="more">查看详情>></p>
                </div>
              </el-col>
              <el-col :span="6" :xs="6" class="bg san-2">
                <img :src="getImgSrc(resultShowList[0].result_introduce)" />
                <span class="top2"></span>
              </el-col>
              <el-col :span="6" :xs="6">
                <div class="content" @click="handleMore(resultShowList[1].doc_id, '/ExcellentAchievements', '优秀成果')" style="cursor:pointer">
                  <p class="fontW line1">{{resultShowList[1]?resultShowList[1].result_title:''}}</p>
                  <p class="mt line4">{{resultShowList[1].doc_abstract?resultShowList[1].doc_abstract:''}}</p>
                  <p class="more">查看详情>></p>
                </div>
              </el-col>
              <el-col :span="6" :xs="6" class="bg san-2">
                <img :src="getImgSrc(resultShowList[1].result_introduce)" />
                <span class="top2"></span>
              </el-col>
          </el-row>
          <el-row class="h-240" v-if="resultShowList">
            <el-col :span="6" :xs="6" class="bg san-1">
                <img :src="getImgSrc(resultShowList[2].result_introduce)" />
              <span class="top"></span>
            </el-col>
            <el-col :span="6" :xs="6">
              <div class="content" @click="handleMore(resultShowList[2].doc_id, '/ExcellentAchievements', '优秀成果')" style="cursor:pointer">
                <p class="fontW line1">{{resultShowList[2]?resultShowList[2].result_title:''}}</p>
                <p class="mt line4">{{resultShowList[2].doc_abstract?resultShowList[2].doc_abstract:''}}</p>
                <p class="more">查看详情>></p>
              </div>
            </el-col>
            <el-col :span="6" :xs="6" class="bg san-1">
                <img :src="getImgSrc(resultShowList[3].result_introduce)" />
              <span class="top"></span>
            </el-col>
            <el-col :span="6" :xs="6">
              <div class="content" @click="handleMore(resultShowList[3].doc_id, '/ExcellentAchievements', '优秀成果')" style="cursor:pointer">
                <p class="fontW line1">{{resultShowList[3]?resultShowList[3].result_title:''}}</p>
                <p class="mt line4">{{resultShowList[3].doc_abstract?resultShowList[3].doc_abstract:''}}</p>
                <p class="more">查看详情>></p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getPortalIndustryDynamicListApi,
  getPortalNewestNoticeListApi,
  getPortalResultShowListApi,
  getIndustryEliteListApi,
  getIndustryDynamicNewImageApi,
  getSearchScopeListApi
} from "@/api"
import Swiper from './component/swiper.vue'
export default {
  name: 'home',
  components: {
    // Swiper
  },
  data () {
    return {
      options: [],
      searchInfo: {},
      activeName: '0',
      industryTabs:[{label:'协会动态', name: '0'},{label:'通知公告', name: '1'},{label:'行业活动', name: '2'},{label:'行业发展', name: '3'},{label:'党建活动', name: '4'}],
      imageList:[],
      industryDynamicList:[],
      industryActivityList:[],
      newnestList:[],
      eliteList:[],
      industryEliteList:[],
      resultShowList:[],
      developListList:[],      
      selectList:[],
      selectList2:[{id:'1', label:'正文'}, {id:'2', label:'标题'}],
    }
  },
  mounted() {
	  var hash = window.location.hash;    
    var index = hash.lastIndexOf("#target");
    if (index != -1) {
      console.log('targettargettargettargettargettarget',hash)
      window.location.hash="#target";
        this.$nextTick(() => {
          const returnEle = document.querySelector("#target");  //productId是将要跳转区域的id
          if (!!returnEle) {
            returnEle.scrollIntoView(true); // true 是默认的
          }
        });
    }
  },
  computed: {
  //这里设置banner 是在1100像素下高度为388px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w = document.documentElement.clientWidth || document.body.clientWidth;
      if (_w <= 1600) {
        return (_w * 190) / 1100 + "px";
      } else {
        return (_w * 240) / 1200 + "px";
      }
    },
  },
  created(){
    this.init();
  },
  methods: {
    init(){
      this.imageList = []
      // 行业动态
      this.getIndustryList('0', 'init')
      //最新公告
      this.getNewestList()
      //行业精英
      if (localStorage.getItem('eliteList_session')){
        this.eliteList = JSON.parse(localStorage.getItem('eliteList_session'))
      } else {
        this.getIndustryEliteList()
      }
      //成果展示
      this.GetPortalResultShowList()
      //查询范围
      this.getSelectScopeList()
    },
    async getSelectScopeList(){
        const {data} = await getSearchScopeListApi()
        if (data){
            this.selectList = data
        }
    },
    async getNewImages(){
      const { data } = await getIndustryDynamicNewImageApi()
      if (data) {
        this.imageList = data
      }
    },
    async getIndustryList(tab, initFlg){
      const { data } = await getPortalIndustryDynamicListApi({industryType: tab})
      if (data) {
        this.industryDynamicList = data.docBase
        if(initFlg==='init') {
          this.setImgList(data.docBase)
          this.industryTabs.forEach((item, index) => {
            if (index===0) {
              item.count=data.count1.count
            }
            if (index===1) {
              item.count=data.count2.count
            }
            if (index===2) {
              item.count=data.count3.count
            }
            if (index===3) {
              item.count=data.count4.count
            }
            if (index===4) {
              item.count=data.count5.count
            }
          })
        }
      }
    },
    async getNewestList () {
      const { data } = await getPortalNewestNoticeListApi()
      if (data) {
        this.newnestList = data
      }
    },
    async getIndustryEliteList () {
      const { data } = await getIndustryEliteListApi()
      if (data) {
        this.industryEliteList = data
        this.eliteList = []
        var list = []
        this.industryEliteList.forEach((info, index)=> {
          let elite = info
          let imginfo = this.getImgSrc(info.elite_company)
          elite.img_url = imginfo
          list.push(elite)
        })
        this.eliteList = list
        localStorage.setItem('eliteList_session', JSON.stringify(list));
      }
    },
    async GetPortalResultShowList () {
      const { data } = await getPortalResultShowListApi()
      if (data) {
        this.resultShowList = data
      }
    },
    getNewFlg(showDate){
      return Math.abs(new Date(showDate.substring(0,10)) - new Date()) < 8*24*3600*1000
    },
    goTotalSearch () {
      this.$router.push({
        path: '/TotalSearch',
        query: { searchInfo: JSON.stringify(this.searchInfo) }
      })
    },
    jumpDocInfo(docId, index){
      var position = ''
      var positionName = ''
      if (index === 1) {
        position = '/AssociationWork?tab=1'
        positionName = '协会工作'
      } else if (index === 2 || index === 5) {
        position = '/AssociationWork?tab=2'
        positionName = '协会工作'
      } else if (index === 3) {
        position = '/IndustryDynamic?tab=1'
        positionName = '行业动态'
      } else if (index === 4) {
        position = '/IndustryDynamic?tab=2'
        positionName = '行业动态'
      }
      this.$router.push({
          path: '/DetailsPage',
          query: {
              docId: docId,
              position: position,
              positionName: positionName
          }
      }, () => {})
    },
    goGaozhiDetail(id){
      this.$router.push({
          path: '/DetailsPage',
          query: {
              docId: id
          }
      }, () => {})
    },
    handleJump(path){
      this.$router.push({
          path: path,
          query: {}
      }, () => {})
    },
    jumpImgPage(flg){
      if (flg === '1' || flg === '0') {//协会工作
        this.$router.push({
          path: '/AssociationWork',
          query: { tab: flg === '0'?'1':'2' }
        }, () => {})
      } else if (flg === '3' || flg === '2') { //行业动态
        this.$router.push({
          path: '/IndustryDynamic',
          query: { tab: flg === '2'?'1':'2' }
        }, () => {})
      } else {
        this.$router.push({
          path: '/PartyBuildingGarden',
          query: { tab: '2' }
        }, () => {})
      }
    },
    jumpDangPage(){
      this.$router.push({
        path: '/PartyBuildingGarden',
        query: { tab: '3' }
      }, () => {})
    },
    // 获取图片地址
	
    getImgSrc(info, forceHttps = false){
    let srcSource = null
    let imgInfo
    if (typeof info === "string") {
        srcSource = info.match(/src="([^"]*)"/g);
    }
    if (srcSource) {
        let imgList = srcSource[0].split('src=')
        imgInfo = imgList[1].replace("\"","").replace("\"","")
        
        // 根据参数决定是否强制转 HTTPS
        if (forceHttps && imgInfo && imgInfo.startsWith('http://')) {
            imgInfo = imgInfo.replace('http://', 'https://')
        }
    }
    return imgInfo
},
	
    setImgList(list){
      if (list){
        list.forEach((item, index)=> {
          if (index < 5) {
            let imginfo = this.getImgSrc(item.industry_content)
            let info = {
              img: imginfo,
              title: item.industry_title,
              docId: item.doc_id
            }
            this.imageList.push(info)
          }
        })
      }
    },
    handleMore(docId, position, positionName){
      this.$router.push({
          path: '/DetailsPage',
          query: {
              docId: docId,
              position: position,
              positionName: positionName
          }
      }, () => {})
    },
    handlePersonInfo(personId){
      this.$router.push({
        path: '/DetailsTowPage',
        query: {
            personId: personId
        }
      }, () => {})
    },
    goOASystem(){
      window.open( CONFIG.LOGIN_URL, "_blank")
    },
    goRsj(url){
      window.open(url, '_blank')
    },
    handleClick (tab) {
      console.log(tab.index)
      this.getIndustryList(tab.index)
    }
  }
}
</script>
<style lang="scss" scoped>
.home{
  height: auto;
  text-align: center;
  margin: 0 auto;

  .party{
    position: fixed;
    z-index: 999;
    text-align: right;
    right:20px;
    top:10%;
    cursor: pointer;
    .partyRight{
      right:10px;
      top:10px;
      left: 20px;
      width: 300px;
    }
  }
  .search{
    border: solid 2px #F0F0F0;
    min-width: calc(1440px * 0.85);
    margin: 0 auto;
    height: 93px;
    line-height: 45px;
    text-align: left;
    display: flex;
    img{
      height: 90px;
      margin-right: 1.25rem;
    }
    .search-mt{
      // min-width: calc(1440px * 0.8 *0.8);
      margin-top: 18px;
      line-height: 45px;
      text-align: left;
      span{
        width: 9.95rem;
        font-size: var(--fontSize);
      }
    }
  }
  .title{
    margin: 20px 0 0 0;
    &-l{
      text-align: left;
      font-size: var(--contentTitleFS);
      font-weight: 600px;
      p{
        margin: 0 0 0 10px;
      }
      img{
        width: var(--contentTitleImg);
        margin-top: -10px;
      }
    }
  }
  .row-col{
    display: flex;
    label{
      white-space: nowrap;
      width: 110px;
    }
  }
  .row1{
    min-width: var(--minScreen);
    &-l{
      text-align: left;
      float: left;
      .info{
        position: absolute;
        bottom: 0;
        width: 230px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        margin-top: 20px;
        background: #164DA0;
        color: #fff;
        border-radius: 0;
      }
    }
    &-r{
      // margin-left: var(--tabMl);
      // border: solid 2px red;
      width: var(--imgW);
      // text-align: right;
      float: right;
      position: relative;
      img{
        width:100%;
        height: 92%;
        display: block; 
        object-fit: cover;
        float: left;
      }
      div{
        text-align: left;
        font-weight: 600;
      }
      
    }
  }
  .box-card {
    max-width: 480px;
    height: 140px;
    border-radius: 2px;
    margin-top: -10px;
  }
  .box-card:hover{
    background: #164DA0;
    color: #fff;
  }
  .h-240{
    width: 90%;
    height: var(--rowHeight);
    padding: 0;
    margin: 0 auto;
    padding-right: 0;
    background: #277CC6;
    color: #254A8A;
    display: flex;
    color: #fff;
    text-align: left;
    .san-1{
      position: relative;
      .top {
        position: absolute;
        width:0; height:0; 
        border-width:12px; 
        border-style:solid dashed dashed; 
        border-color:#277CC6 transparent transparent;
        left: 47%;
        top: 0px;
      }
    }
    .san-2{
      position: relative;
      .top2 {
        position: absolute;
        width:0; height:0; 
        border-width:12px; 
        border-style: dashed dashed solid; 
        border-color: transparent transparent #277CC6;
        left: 48%;
        text-align: center;
        bottom: 0px;
      }
    }

    .bg{
      img{
        height: 100%;
        width: 100%;
      }
    }
    .content{
      margin: 20px;
      .fontW{
        font-size: var(--fontSize);
        font-weight: 600;
      }
      p{
        font-size: var(--fontSizeS);
      }
      .more{
        line-height: var(--fontMoreLH);
        cursor: pointer;
        font-size: 12px;
      }
      .arrow {
        display:inline-block;
        height:2px;
        width:40px;
        background-color:#fff;
        position:relative;
        top:0px;left:20px;
      }
      .arrow:before {
        position:absolute;
        content:"";
        width:0;
        height:0;
        border:3px solid transparent;
        border-left:8px solid #fff;
        left:40px;
        top:-2px;
      }
    }
  }
  .h-260-title{
    width: 75%;
    margin: 0 auto !important;
  }  
  .h-260-title2{
    width: 100%;
    margin: 0 auto !important;
  }
  .h-260{
    width: 65%;
    height: var(--hight);
    margin: 15px auto !important;
    background: #fff;
    color: #254A8A;
    display: flex;
    align-items: center;
    img{
      margin-top:10px;
      width: 60px;
    }
    .border-r{
      border-right: solid 1px #ccc;
    }
    p{
      font-size: var(--fontSizeL);
      cursor: pointer;
    }
    a{
      color: #254A8A;
      text-decoration: none;
    }
  }
  .h-460{
    width: 100%;
    margin: var(--personM) !important;
    color: #254A8A;
    .border-r{
      border-right: solid 1px #ccc;
    }
  }
}
.home-m{
  width: var(--mainPageWidth);
  min-width: calc(var(--minScreen) * 0.75);
  margin: 0 auto;
}
.home-75{
  width: var(--mainPageWidth);
  
  min-width: calc(var(--minScreen) * 0.85);
  margin: 0 auto;
}
.home-full{
  width: 100%;
  min-width: var(--minScreen);
  margin: 0 auto;
  background-image: url('../../assets/images/1-2.jpg');
  background-size: 100% 100%;
  height: var(--hight2);
}
.home-full-2{
  // border: solid 1px #fff;
  // border-bottom: solid 1px #0F4186;
  width: 100%;
  min-width: var(--minScreen);
  margin: 0 auto;
  padding: 0;
  background-image: url('../../assets/images/1234.jpg');
  background-size: 100% 100%;
  height: 551px;
}
.home-full-3{
  width: 100%;
  min-width: var(--minScreen);
  margin: 0 auto;
  padding: 0;
  // background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), url('../../assets/images/111.png');
  
  background-image: url('../../assets/images/111.png');
  background-size: 100% 100%;
  height: var(--hight3);
  background-color: rgba(255, 255, 255, 0.2);
  margin-top:-20px;
}
.line{
  height: 1px;
  background-color: #164DA0;
  width: 60px;
  margin: 5px 0;
}
.btn{
  position: absolute;
  bottom: 0;
  width: 230px;
  height: 45px;
  line-height: 30px;
  background: #164DA0;
  color: #fff;
  border-radius: 0;
}
.btn-search{
  margin: 5px 0 0 5px;
  width: 100px;
  height: 38px;
  line-height: 5px;
  background: #164DA0;
  color: #fff;
  border-radius: 0;
  border: none;
}
.btn-g{
  position: absolute;
  bottom: 0;
  text-align: left;
  color: #ABABAB;
  font-size: 12px;
  margin-bottom: 10px;
  cursor: pointer;
}
.btn-s{
  padding-top: 10px;
  width: 130px;
  height: 38px;
  line-height: 15px;
  background: #164DA0;
  color: #fff;
  border-radius: 5px;
  border: none;
}
.mt-5{
  &-img{
    width: 35px;
    cursor: pointer;
  }
}
.tab-info{
  line-height: var(--ul-li-LH);
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: -webkit-ellipsis-lastline;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;  
  img{
    margin: -5px 5px 0 0;
    width:34px; 
    line-height: 30px;
    image-rendering: -webkit-optimize-contrast; /* 针对WebKit引擎 */
    image-rendering: crisp-edges; /* WebKit引擎现不支持该值，Firefox支持 */
  }
  .tabspan{
    text-align: left;
    margin-left: 39px;
    width: 60%;
  }
}
.title-span{
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: -webkit-ellipsis-lastline;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;  
}
.tabspan-r{
  float: right;
  line-height: var(--ul-li-LH);
}
.tab-more{
  border: solid 1px #ccc;
  border-radius: 5px;
  width: 85px;
  height: 35px;
  line-height: 32px;
  text-align: center;
  margin: -5px 0 0 10px;
  color: rgb(155, 154, 154);
  font-size: var(--fontSize);
  float: right;
}
.tab-more:hover{
  color:#ffffff;
  background: #0F4186;
}
.tab-more-elite{
  border: solid 1px #ccc;
  border-radius: 5px;
  width: 125px;
  height: 35px;
  line-height: 32px;
  text-align: center;
  margin: 15px 0 0 10px;
  color: #ccc;
  font-size: var(--fontSize);
  float: right;
}
.tab-more-black{
  border: solid 1px #666;
  border-radius: 5px;
  width: 125px;
  height: 35px;
  line-height: 32px;
  text-align: center;
  margin: 15px 0 0 10px;
  color: #666;
  font-size: var(--fontSize);
  float: right;
}
.row-tab:hover{
  color: red;
}
</style>
<style lang="scss">
.tab-r{
  line-height: 25px;
  width: 100%;
  margin-left: 10px;
  .el-tabs__item.is-active{
    color:#164DA0;
    font-size: var(--fontSizeL);
    font-weight: 700;
  }
  .el-tabs__item{
    font-size: var(--fontSizeL);
  }
  .el-tabs__active-bar{
    background: #164DA0;
  }
}
.imgBoxNew {
  position: relative;
  .imgItem {
    padding:5px;
    width: 320px;
    height: 320px;
    text-align: center;
    border-radius: 50%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .imgItem:hover{
    width: 310px;
    height: 310px;
    border: 2px solid #DADEE3;
  }
}
.imgTit{
  color: #ccc;
  margin: 10px 0;
  line-height: 35px;
  font-size: var(--fontSizeL);
}
.imgTit2{
  color: #ccc;
  margin: 0 auto;
  text-align: center;
  line-height: 25px;
  font-size: 16px;
  width:280px;
  font-weight: 600;
}
.service{
  color: #fff;
  text-shadow: 0.1em 0.1em 0.6em #164DA0, 0 0 0.6em #164DA0, 0 0 0.6em #164DA0; //霓虹灯
  // text-shadow: 0.1em 0.1em 0.6em #c41111, 0 0 0.6em #b91616, 0 0 0.6em #a01616; //霓虹灯
  
}
.carousel{
  .el-carousel__mask{
    background: none;
  }
}
</style>
